import { render, staticRenderFns } from "./EditDeveloperSlugModal.vue?vue&type=template&id=2218e5c4"
import script from "./EditDeveloperSlugModal.vue?vue&type=script&lang=js"
export * from "./EditDeveloperSlugModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports